import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/2de4239l_05a726dd-173c-4b83-9e50-8e529e041a31.jpeg',
      alt: 'Tomás Roco en acción'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/hkhp5fqq_c00cf60d-577e-45da-92d0-fd356dbc8778.jpeg',
      alt: 'Tomás Roco portrait'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/v8f1vijd_279198f3-8d40-449d-b5a9-a90ab2cfbf91.jpeg',
      alt: 'Tomás Roco celebración'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/rhgrbqsc_4820cfe4-e26c-4049-9d0e-dab7a0252b94.jpeg',
      alt: 'Tomás Roco en el campo'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/pyz8zxs7_cf9e5ab7-034c-49cc-8677-6998e8123d3e.jpeg',
      alt: 'Tomás Roco jugando'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold mb-4 tracking-wide"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            {t.gallery.title}
          </h2>
          <div className="h-1 w-20 bg-red-600 mx-auto mb-4" />
          <p className="text-gray-400 text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.gallery.subtitle}
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-xl aspect-[3/4]"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <p className="text-white font-semibold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {image.alt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-red-600 text-4xl font-bold"
            onClick={() => setSelectedImage(null)}
          >
            ×
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
